"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreSimpleGrid = _interopRequireDefault(require("@vfuk/core-simple-grid"));

var _coreMatchMedia = require("@vfuk/core-match-media");

var _coreAnimate = _interopRequireDefault(require("@vfuk/core-animate"));

var Styled = _interopRequireWildcard(require("./styles/MainBar.style"));

var _Logo = _interopRequireDefault(require("./components/Logo"));

var _PrimaryNav = _interopRequireDefault(require("./components/PrimaryNav"));

var _SecondaryNav = _interopRequireDefault(require("./components/SecondaryNav"));

var _SearchBar = _interopRequireDefault(require("./components/SearchBar"));

var _MobileNavTrigger = _interopRequireDefault(require("./components/MobileNavTrigger"));

var _TopNavigationContext = _interopRequireDefault(require("../../context/TopNavigationContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MainBar = function MainBar() {
  var _ref = (0, _react.useContext)(_TopNavigationContext["default"]),
      showSearch = _ref.showSearch,
      animationDuration = _ref.animationDuration,
      primaryNav = _ref.primaryNav,
      secondaryNav = _ref.secondaryNav;

  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
      mdAndBelow = _useBreakpoints.mdAndBelow;

  return /*#__PURE__*/_react["default"].createElement(Styled.MainBar, null, /*#__PURE__*/_react["default"].createElement(Styled.Container, null, /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
    layout: {
      sm: [2, 10],
      lg: [1, 11]
    },
    justify: "left",
    verticalAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], null), /*#__PURE__*/_react["default"].createElement(Styled.NavWrapper, null, /*#__PURE__*/_react["default"].createElement(_SearchBar["default"], null), /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
    show: !showSearch,
    enter: {
      animations: ['fadeIn'],
      duration: animationDuration
    },
    exit: {
      animations: ['fadeOut'],
      duration: animationDuration
    }
  }, /*#__PURE__*/_react["default"].createElement(Styled.MainBarContents, {
    "aria-label": primaryNav.srText
  }, primaryNav ? mdAndBelow ? /*#__PURE__*/_react["default"].createElement(_MobileNavTrigger["default"], null) : /*#__PURE__*/_react["default"].createElement(_PrimaryNav["default"], null) : null, secondaryNav ? /*#__PURE__*/_react["default"].createElement(_SecondaryNav["default"], null) : null))))));
};

MainBar.displayName = "MainBar";
var _default = MainBar;
exports["default"] = _default;
//# sourceMappingURL=MainBar.js.map